import { render, staticRenderFns } from "./ElecticAustor.vue?vue&type=template&id=4d3ae9e3&scoped=true&"
import script from "./ElecticAustor.vue?vue&type=script&lang=js&"
export * from "./ElecticAustor.vue?vue&type=script&lang=js&"
import style0 from "./ElecticAustor.vue?vue&type=style&index=0&id=4d3ae9e3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3ae9e3",
  null
  
)

export default component.exports